module.exports = __webpack_public_path__ + "img/Muschel.7726c250.png";